<template>
  <div class="thank-you-container">
    <h1>Thank you.</h1>
    <p v-if="amount && email">
      Your gift of {{ amount }} to OU Torah is confirmed. A receipt is on its way to {{ email }}.
    </p>
    <p v-else>Your gift to OU Torah is confirmed. A receipt is on its way to your email.</p>
    <p>
      Tomorrow morning, your shiur will arrive the way it always does. Now you keep it arriving
      for everyone else.
    </p>
    <p>
      Questions? Contact <a href="mailto:donorservices@ou.org">donorservices@ou.org</a>.
    </p>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

defineProps<{
  message?: string
}>()

const paymentForm = usePaymentForm()

const amount = computed(() => {
  const request = paymentForm?.request.value
  const value = Number(request?.amount)
  if (!request || !value) return ''
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: request.currency || 'USD',
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2
  }).format(value)
})

const email = computed(() => paymentForm?.request.value?.email || '')
</script>

<style scoped>
.thank-you-container {
  padding: 30px 20px;
  min-height: 300px;
  margin: 0 auto;
  max-width: 720px;
  background: #dff9e1;
  color: #222;
  line-height: 1.5;
  font-size: 18px;
  font-weight: 400;
  text-align: center;
  border-radius: 10px;
}

.thank-you-container h1 {
  color: #4f1014;
  font-weight: 900;
  margin: 0 0 20px;
}

.thank-you-container p {
  margin: 0 0 16px;
}

.thank-you-container a {
  color: #4f1014;
}
</style>
